export default __webpack_public_path__ + "static/media/img1.deba33b3.svg";